import { IIconProps, Icon } from "native-base";
import React from "react";
import { Circle, Path, Rect } from "react-native-svg";

interface Props extends Omit<IIconProps, "color"> {
  color?: string;
  activeColor?: string;
}

const TileFillIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect x="2.5" y="2.5" width="8" height="8" rx="1" fill={color} />
      <Rect x="2.5" y="13.5" width="8" height="8" rx="1" fill={color} />
      <Rect x="13.5" y="2.5" width="8" height="8" rx="1" fill={color} />
      <Rect x="13.5" y="13.5" width="8" height="8" rx="1" fill={color} />
    </Icon>
  );
};

const LockFillIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10H19C20.1046 10 21 10.8954 21 12V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10ZM13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13Z"
        fill={color}
      />
      <Path
        d="M7 10V6.89063C6.99876 5.92676 7.45631 4.99692 8.28382 4.28161C9.11132 3.5663 10.2498 3.11655 11.4781 3.01969C12.7065 2.92282 13.9371 3.18574 14.9311 3.7574C15.9251 4.32907 16.6116 5.1687 16.8573 6.11329C17.103 7.05788 16.9569 10 16.9569 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const SoundMuteIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M3.27031 14.1386C2.4873 12.8204 2.4873 11.1796 3.27031 9.86142C3.51207 9.45443 3.91474 9.16874 4.37874 9.075L6.2513 8.69671C6.34824 8.67712 6.43715 8.62914 6.50673 8.55886L10.263 4.76469C11.4267 3.58919 12.0086 3.00144 12.5043 3.20531C13 3.40918 13 4.23624 13 5.89036L13 18.1096C13 19.7638 13 20.5908 12.5043 20.7947C12.0086 20.9986 11.4267 20.4108 10.263 19.2353L6.50673 15.4411C6.43715 15.3709 6.34824 15.3229 6.2513 15.3033L4.37874 14.925C3.91474 14.8313 3.51207 14.5456 3.27031 14.1386Z"
        fill={color}
      />
      <Path
        d="M16 15L22 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M22 15L16 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const SoundMinIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M3.27031 14.1386C2.4873 12.8204 2.4873 11.1796 3.27031 9.86142C3.51207 9.45443 3.91474 9.16874 4.37874 9.075L6.2513 8.69671C6.34824 8.67712 6.43715 8.62914 6.50673 8.55886L10.263 4.76469C11.4267 3.58919 12.0086 3.00144 12.5043 3.20531C13 3.40918 13 4.23624 13 5.89036L13 18.1096C13 19.7638 13 20.5908 12.5043 20.7947C12.0086 20.9986 11.4267 20.4108 10.263 19.2353L6.50673 15.4411C6.43715 15.3709 6.34824 15.3229 6.2513 15.3033L4.37874 14.925C3.91474 14.8313 3.51207 14.5456 3.27031 14.1386Z"
        fill={color}
      />
      <Path
        d="M17.5355 8.46447C18.4684 9.39732 18.9948 10.6611 19 11.9803C19.0052 13.2996 18.4888 14.5674 17.5633 15.5076"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const SettingFillIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9838 2.54161C14.0711 2.71093 14.0928 2.92777 14.1361 3.36144C14.2182 4.1823 14.2593 4.59274 14.4311 4.81793C14.649 5.10358 15.0034 5.25038 15.3595 5.20248C15.6402 5.16472 15.9594 4.90352 16.5979 4.38113C16.9352 4.10515 17.1038 3.96716 17.2853 3.90918C17.5158 3.83555 17.7652 3.84798 17.9872 3.94419C18.162 4.01994 18.3161 4.17402 18.6243 4.4822L19.5178 5.37567C19.8259 5.68385 19.98 5.83794 20.0558 6.01275C20.152 6.23478 20.1644 6.48415 20.0908 6.71464C20.0328 6.89612 19.8948 7.06478 19.6188 7.4021C19.0964 8.0406 18.8352 8.35984 18.7975 8.64056C18.7496 8.99662 18.8964 9.35102 19.182 9.56893C19.4072 9.74072 19.8176 9.78176 20.6385 9.86385C21.0722 9.90722 21.2891 9.92891 21.4584 10.0162C21.6734 10.1272 21.841 10.3123 21.9299 10.5373C22 10.7145 22 10.9324 22 11.3682V12.6319C22 13.0676 22 13.2855 21.93 13.4626C21.841 13.6877 21.6734 13.8729 21.4583 13.9838C21.289 14.0711 21.0722 14.0928 20.6386 14.1361L20.6386 14.1361C19.818 14.2182 19.4077 14.2592 19.1825 14.4309C18.8967 14.6489 18.7499 15.0034 18.7979 15.3596C18.8357 15.6402 19.0968 15.9593 19.619 16.5976C19.8949 16.9348 20.0328 17.1034 20.0908 17.2848C20.1645 17.5154 20.152 17.7648 20.0558 17.9869C19.98 18.1617 19.826 18.3157 19.5179 18.6238L18.6243 19.5174C18.3162 19.8255 18.1621 19.9796 17.9873 20.0554C17.7652 20.1516 17.5159 20.164 17.2854 20.0904C17.1039 20.0324 16.9352 19.8944 16.5979 19.6184L16.5979 19.6184C15.9594 19.096 15.6402 18.8348 15.3595 18.7971C15.0034 18.7492 14.649 18.896 14.4311 19.1816C14.2593 19.4068 14.2183 19.8173 14.1362 20.6383C14.0928 21.0722 14.0711 21.2891 13.9837 21.4585C13.8728 21.6735 13.6877 21.8409 13.4628 21.9299C13.2856 22 13.0676 22 12.6316 22H11.3682C10.9324 22 10.7145 22 10.5373 21.9299C10.3123 21.841 10.1272 21.6734 10.0162 21.4584C9.92891 21.2891 9.90722 21.0722 9.86385 20.6385C9.78176 19.8176 9.74072 19.4072 9.56892 19.182C9.35101 18.8964 8.99663 18.7496 8.64057 18.7975C8.35985 18.8352 8.04059 19.0964 7.40208 19.6189L7.40206 19.6189C7.06473 19.8949 6.89607 20.0329 6.71458 20.0908C6.4841 20.1645 6.23474 20.152 6.01272 20.0558C5.8379 19.9801 5.6838 19.826 5.37561 19.5178L4.48217 18.6243C4.17398 18.3162 4.01988 18.1621 3.94414 17.9873C3.84794 17.7652 3.8355 17.5159 3.90913 17.2854C3.96711 17.1039 4.10511 16.9352 4.3811 16.5979C4.90351 15.9594 5.16471 15.6402 5.20247 15.3594C5.25037 15.0034 5.10357 14.649 4.81792 14.4311C4.59273 14.2593 4.1823 14.2182 3.36143 14.1361C2.92776 14.0928 2.71093 14.0711 2.54161 13.9838C2.32656 13.8728 2.15902 13.6877 2.07005 13.4627C2 13.2855 2 13.0676 2 12.6318V11.3683C2 10.9324 2 10.7144 2.07008 10.5372C2.15905 10.3123 2.32654 10.1272 2.54152 10.0163C2.71088 9.92891 2.92777 9.90722 3.36155 9.86384H3.36155H3.36156C4.18264 9.78173 4.59319 9.74068 4.81842 9.56881C5.10395 9.35092 5.2507 8.99664 5.20287 8.64066C5.16514 8.35987 4.90385 8.04052 4.38128 7.40182C4.10516 7.06435 3.96711 6.89561 3.90914 6.71405C3.83557 6.48364 3.848 6.23438 3.94413 6.01243C4.01988 5.83754 4.17403 5.68339 4.48233 5.37509L5.37565 4.48177L5.37566 4.48177C5.68385 4.17357 5.83795 4.01947 6.01277 3.94373C6.23478 3.84753 6.48414 3.8351 6.71463 3.90872C6.89612 3.9667 7.06481 4.10472 7.4022 4.38076C8.04061 4.9031 8.35982 5.16427 8.64044 5.20207C8.99661 5.25003 9.35113 5.10319 9.56907 4.81742C9.74077 4.59227 9.78181 4.18195 9.86387 3.36131C9.90722 2.92776 9.9289 2.71098 10.0162 2.5417C10.1271 2.32658 10.3123 2.15898 10.5374 2.07001C10.7145 2 10.9324 2 11.3681 2H12.6318C13.0676 2 13.2855 2 13.4627 2.07005C13.6877 2.15902 13.8728 2.32656 13.9838 2.54161ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        fill={color}
      />
    </Icon>
  );
};

const MusicFillIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9 11V9.27922C9 7.70946 9 6.92459 9.45332 6.37163C9.90663 5.81867 10.6763 5.66475 12.2155 5.35689L14.2155 4.95689C16.4291 4.51417 17.536 4.29281 18.268 4.89292C19 5.49304 19 6.62176 19 8.87922V9V14V15.9505C19 16.3385 19 16.5325 18.9706 16.7021C18.8506 17.394 18.3765 17.9724 17.7215 18.2257C17.561 18.2878 17.3708 18.3258 16.9903 18.4019L16.9903 18.4019L16.6942 18.4612C16.4199 18.516 16.2827 18.5435 16.1714 18.553C15.0909 18.646 14.1332 17.8609 14.0124 16.7831C14 16.6721 14 16.5322 14 16.2525C14 16.018 14 15.9008 14.0098 15.802C14.1041 14.854 14.854 14.1041 15.802 14.0098C15.9008 14 16.018 14 16.2525 14H19V9L9 11V16V17.9505C9 18.3385 9 18.5325 8.9706 18.7021C8.85063 19.394 8.3765 19.9724 7.7215 20.2257C7.56099 20.2878 7.37076 20.3258 6.99029 20.4019L6.69419 20.4612L6.69407 20.4612C6.41982 20.516 6.28267 20.5435 6.17139 20.553C5.0909 20.646 4.13321 19.8609 4.01244 18.7831C4 18.6721 4 18.5322 4 18.2525C4 18.018 4 17.9008 4.00982 17.802C4.10411 16.854 4.85403 16.1041 5.80205 16.0098C5.90078 16 6.018 16 6.25245 16H9V11Z"
        fill={color}
      />
      <Path
        d="M9 16H6.25245C6.018 16 5.90078 16 5.80205 16.0098C4.85403 16.1041 4.10411 16.854 4.00982 17.802C4 17.9008 4 18.018 4 18.2525V18.2525C4 18.5322 4 18.6721 4.01244 18.7831C4.13321 19.8608 5.0909 20.646 6.17139 20.553C6.28269 20.5435 6.41986 20.516 6.69419 20.4612L6.99029 20.4019C7.37076 20.3258 7.56099 20.2878 7.7215 20.2257C8.3765 19.9724 8.85063 19.394 8.9706 18.7021C9 18.5325 9 18.3385 9 17.9505V9.27922C9 7.70946 9 6.92459 9.45332 6.37163C9.90663 5.81867 10.6763 5.66475 12.2155 5.35689L14.2155 4.95689C16.4291 4.51417 17.536 4.29281 18.268 4.89292C19 5.49304 19 6.62176 19 8.87922V9M19 14V15.9505C19 16.3385 19 16.5325 18.9706 16.7021C18.8506 17.394 18.3765 17.9724 17.7215 18.2257C17.561 18.2878 17.3708 18.3258 16.9903 18.4019L16.6942 18.4612C16.4199 18.516 16.2827 18.5435 16.1714 18.553C15.0909 18.646 14.1332 17.8608 14.0124 16.7831C14 16.6721 14 16.5322 14 16.2525V16.2525C14 16.018 14 15.9008 14.0098 15.802C14.1041 14.854 14.854 14.1041 15.802 14.0098C15.9008 14 16.018 14 16.2525 14H19ZM19 14V9M19 9L9 11"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const WalletIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M20 5C20.5523 5 21 4.55228 21 4C21 3.44772 20.5523 3 20 3V5ZM5.50001 5L20 5V3L5.50001 3L5.50001 5ZM5.50001 10H13.5V8L5.50001 8V10ZM4.00001 6.5C4.00001 5.67157 4.67158 5 5.50001 5L5.50001 3C3.56701 3 2.00001 4.567 2.00001 6.5L4.00001 6.5ZM2.00001 6.5C2.00001 8.433 3.56701 10 5.50001 10V8C4.67158 8 4.00001 7.32843 4.00001 6.5L2.00001 6.5Z"
        fill={color}
      />
      <Path d="M4 12L4 6.5H2L2 12H4Z" fill={color} />
      <Path
        d="M3 8.5H2.5V9L2.5 19V19.0329C2.49998 19.4762 2.49995 19.8581 2.54107 20.1639C2.58514 20.4917 2.68451 20.8058 2.93934 21.0607L2.93934 21.0607C3.19417 21.3155 3.50835 21.4149 3.83611 21.4589C4.14193 21.5 4.52384 21.5 4.96708 21.5L5 21.5L19 21.5C19.011 21.5 19.022 21.5 19.0329 21.5C19.4762 21.5 19.8581 21.5 20.1639 21.4589C20.4917 21.4149 20.8058 21.3155 21.0607 21.0607C21.3155 20.8058 21.4149 20.4917 21.4589 20.1639C21.5 19.8581 21.5 19.4762 21.5 19.0329C21.5 19.022 21.5 19.011 21.5 19V18V17.5H21H18C16.6193 17.5 15.5 16.3807 15.5 15C15.5 13.6193 16.6193 12.5 18 12.5H21H21.5V12V11L21.5 10.9671C21.5 10.5238 21.5 10.1419 21.4589 9.8361C21.4149 9.50835 21.3155 9.19417 21.0607 8.93934C20.8058 8.68451 20.4917 8.58514 20.1639 8.54107C19.8581 8.49995 19.4762 8.49997 19.0329 8.5L19 8.5L3 8.5Z"
        fill={color}
        stroke={color}
      />
    </Icon>
  );
};

const HeadPhonesIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="16"
        y="12"
        width="4"
        height="7"
        rx="2"
        fill={color}
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <Rect
        x="4"
        y="12"
        width="4"
        height="7"
        rx="2"
        fill={color}
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <Path
        d="M4 13V16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20 13V16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20 13C20 10.6131 19.1571 8.32387 17.6569 6.63604C16.1566 4.94821 14.1217 4 12 4C9.87827 4 7.84344 4.94821 6.34315 6.63604C4.84286 8.32387 4 10.6131 4 13"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const GuitarIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M23.0401 3.93614L23.5201 3.45614L23.2801 3.21614L23.1361 3.36014L22.4641 2.68814L22.8001 2.35214C22.9921 2.16014 22.9921 1.82414 22.8481 1.63214L22.6081 1.44014C22.4641 1.29614 22.3201 1.29614 22.1281 1.34414L18.6241 2.49614C18.2401 2.64014 18.1441 3.07214 18.3841 3.36014L18.5761 3.55214L12.5761 9.50414C11.6641 9.31214 10.8961 7.48814 10.9921 6.72014C11.0401 6.33614 10.9921 5.85614 10.6081 5.85614C9.74409 5.90414 8.40009 6.57614 8.06409 7.63214C7.39209 9.55214 5.56809 10.8481 3.55209 11.0881C-0.431908 11.6161 -0.575908 16.6561 2.97609 20.2081C6.52809 23.7601 11.5681 23.5681 12.0481 19.6321C12.2881 17.6641 13.5841 15.7921 15.5041 15.1201C16.5601 14.7361 17.2321 13.4401 17.2801 12.4801C17.2801 12.1441 16.8001 12.1921 16.4641 12.0961C15.6961 11.9041 13.2001 11.0401 13.7761 10.4641L19.6801 4.60814L19.7761 4.70414C19.9681 4.89614 20.2561 4.89614 20.4961 4.65614L20.8321 4.32014L21.5041 4.99214L21.4081 5.08814L21.6481 5.32814L22.1281 4.84814L21.8881 4.60814L21.6961 4.80014L21.0241 4.12814L21.5521 3.60014L22.2241 4.27214L22.0801 4.36814L22.3201 4.60814L22.8001 4.12814L22.5601 3.88814L22.4641 3.98414L21.7921 3.36014L22.2721 2.88014L22.9441 3.55214L22.8481 3.64814L23.0401 3.93614ZM12.0961 12.4321L9.02409 15.5041C8.83209 15.4081 8.64009 15.3121 8.44809 15.1681L11.7601 11.8561C11.9041 12.0481 12.0001 12.2401 12.0961 12.4321ZM8.01609 14.7361C7.87209 14.5441 7.77609 14.4001 7.68009 14.1601L10.7521 11.0881C10.9441 11.1841 11.1361 11.2801 11.3281 11.4241L8.01609 14.7361ZM8.20809 11.6161C8.73609 11.0881 9.40809 10.8961 10.0801 10.9441L7.53609 13.4881C7.44009 12.8161 7.68009 12.1441 8.20809 11.6161ZM7.15209 19.3441L7.10409 19.3921C6.96009 19.5361 6.72009 19.5361 6.57609 19.3921L3.84009 16.6561C3.69609 16.5121 3.69609 16.2721 3.84009 16.1281V16.0321C3.98409 15.8881 4.22409 15.8881 4.36809 16.0321L7.10409 18.7681C7.29609 18.9601 7.29609 19.2001 7.15209 19.3441ZM8.49609 17.9521L8.44809 18.0001C8.30409 18.1441 8.06409 18.1441 7.92009 18.0001L5.18409 15.2641C5.04009 15.1201 5.04009 14.8801 5.18409 14.7361L5.23209 14.6881C5.37609 14.5441 5.61609 14.5441 5.76009 14.6881L8.49609 17.4241C8.64009 17.5681 8.64009 17.8081 8.49609 17.9521ZM11.5681 14.9761C11.0401 15.5041 10.3681 15.6961 9.69609 15.6481L12.2401 13.1041C12.2881 13.8241 12.0481 14.4961 11.5681 14.9761ZM20.6401 3.93614C20.5921 3.93614 20.4961 3.93614 20.4961 3.88814C20.4001 3.79214 20.4001 3.69614 20.4961 3.60014C20.5921 3.50414 20.6881 3.50414 20.7841 3.60014C20.8801 3.69614 20.8801 3.79214 20.7841 3.88814C20.7361 3.88814 20.6881 3.93614 20.6401 3.93614ZM21.1681 2.92814C21.2641 2.83214 21.3601 2.83214 21.4561 2.92814C21.5041 2.97614 21.5041 3.02414 21.5041 3.12014C21.5041 3.16814 21.5041 3.21614 21.4561 3.21614C21.4081 3.26414 21.4081 3.26414 21.3601 3.26414C21.3121 3.26414 21.2161 3.26414 21.1681 3.21614C21.0721 3.12014 21.0721 2.97614 21.1681 2.92814ZM21.8401 2.25614C21.9361 2.16014 22.0321 2.16014 22.1281 2.25614C22.1761 2.30414 22.1761 2.35214 22.1761 2.44814C22.1761 2.49614 22.1281 2.54414 22.1281 2.54414C22.0801 2.59214 22.0801 2.59214 22.0321 2.59214C21.9841 2.59214 21.8881 2.59214 21.8401 2.54414C21.7441 2.44814 21.7441 2.30414 21.8401 2.25614Z"
        fill={color}
      />
    </Icon>
  );
};

const DrumIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M22.3678 21.3118H21.4558V13.0078H22.3678C22.9918 13.0078 23.4718 12.5278 23.4718 11.9038C23.4718 11.2798 22.9918 10.7998 22.3678 10.7998H1.63183C1.00783 10.7998 0.527832 11.2798 0.527832 11.9038C0.527832 12.5278 1.00783 13.0078 1.63183 13.0078H2.54383V21.3118H1.63183C1.00783 21.3118 0.527832 21.7918 0.527832 22.4158C0.527832 23.0398 1.00783 23.5198 1.63183 23.5198H22.3678C22.9918 23.5198 23.4718 23.0398 23.4718 22.4158C23.4718 21.7918 22.9438 21.3118 22.3678 21.3118ZM3.59983 17.0398L5.71183 14.9278L7.82383 17.0398L9.93583 14.9278L12.0478 17.0398L14.1598 14.9278L16.2718 17.0398L18.3838 14.9278L20.4958 17.0398L18.3838 19.1518L16.2718 17.0398L14.1598 19.1518L11.9998 17.0398L9.88783 19.1518L7.77583 17.0398L5.66383 19.1518L3.59983 17.0398Z"
        fill={color}
      />
      <Path
        d="M14.0158 9.69605C14.3038 9.40805 14.3518 9.02405 14.2558 8.68805L21.6958 2.25605C22.0318 1.92005 21.9838 1.29605 21.5518 0.864054C21.1198 0.432054 20.4958 0.336054 20.1598 0.720054L13.6798 8.16005C13.3438 8.01605 12.9598 8.11205 12.6718 8.40005C12.2878 8.78405 12.2878 9.36005 12.6718 9.74405C13.0558 10.1281 13.6798 10.0801 14.0158 9.69605Z"
        fill={color}
      />
      <Path
        d="M9.26402 8.73605C9.12002 9.07205 9.21602 9.45605 9.50401 9.74405C9.88801 10.1281 10.464 10.1281 10.848 9.74405C11.232 9.36005 11.232 8.78405 10.848 8.40005C10.56 8.11205 10.176 8.06405 9.84002 8.16005L3.36002 0.720054C3.02402 0.336054 2.40002 0.432054 1.96802 0.864054C1.53602 1.29605 1.48802 1.92005 1.82402 2.25605L9.26402 8.73605Z"
        fill={color}
      />
    </Icon>
  );
};

const MicrophoneIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M18.2401 8.20801C17.9041 8.20801 17.6641 8.49601 17.6641 8.78401V11.088C17.6641 14.208 15.1201 16.752 12.0001 16.752C8.88008 16.752 6.33608 14.208 6.33608 11.088V8.78401C6.33608 8.44801 6.04808 8.20801 5.76008 8.20801C5.47208 8.20801 5.18408 8.49601 5.18408 8.78401V11.088C5.18408 14.544 7.72808 17.376 11.0401 17.856V21.84H8.35208C7.92008 21.84 7.58408 22.176 7.58408 22.608V22.704C7.58408 23.136 7.92008 23.472 8.35208 23.472H15.6961C16.1281 23.472 16.4641 23.136 16.4641 22.704V22.608C16.4641 22.176 16.1281 21.84 15.6961 21.84H12.9601V17.856C16.2721 17.376 18.8161 14.544 18.8161 11.088V8.78401C18.8161 8.44801 18.5761 8.20801 18.2401 8.20801Z"
        fill={color}
      />
      <Path
        d="M10.3679 11.5685V12.2885H7.63194C8.20794 14.1605 9.93594 15.5525 11.9999 15.5525C14.5439 15.5525 16.6079 13.4885 16.6079 10.9445V5.08847C16.6079 2.54447 14.5439 0.480469 11.9999 0.480469C9.74394 0.480469 7.87194 2.11247 7.48794 4.27247H10.3679V4.99247H7.43994V5.04047V6.09647H10.3679V6.81647H7.43994V7.92047H10.3679V8.64047H7.43994V9.74447H10.3679V10.4645H7.43994V10.9445C7.43994 11.1365 7.43994 11.3285 7.48794 11.5685H10.3679Z"
        fill={color}
      />
    </Icon>
  );
};

const LyreIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M22.4643 13.584C22.0323 11.376 18.4323 4.22399 18.4323 4.22399C18.8643 4.22399 19.2003 4.22399 19.5363 4.17599C21.1683 3.98399 22.0323 2.20799 20.9763 1.05599C19.8243 -0.192006 17.5203 0.623994 16.9443 2.59199C16.8003 3.16799 16.8003 3.64799 16.8003 3.64799C16.7523 4.07999 16.8483 4.65599 16.9923 5.27999H15.8403V3.69599C16.0323 3.55199 16.1763 3.31199 16.1763 3.02399C16.1763 2.59199 15.8403 2.20799 15.3603 2.20799C14.9283 2.20799 14.5443 2.54399 14.5443 3.02399C14.5443 3.31199 14.6883 3.50399 14.8803 3.69599V5.27999H12.4803V2.11199C12.6723 1.96799 12.8163 1.72799 12.8163 1.43999C12.8163 1.00799 12.4803 0.623994 12.0003 0.623994C11.5683 0.623994 11.1843 0.959994 11.1843 1.43999C11.1843 1.72799 11.3283 1.91999 11.5203 2.11199V5.27999H9.07227V3.31199C9.26427 3.16799 9.40827 2.92799 9.40827 2.63999C9.40827 2.20799 9.07227 1.82399 8.59227 1.82399C8.16027 1.82399 7.77627 2.15999 7.77627 2.63999C7.77627 2.92799 7.92027 3.11999 8.11227 3.31199V5.27999H7.00827C7.15227 4.60799 7.20027 4.03199 7.20027 3.64799C7.20027 3.64799 7.15227 3.07199 6.91227 2.35199C6.28827 0.575994 4.12827 -0.144006 3.02427 1.05599C1.96827 2.20799 2.83227 3.98399 4.46427 4.17599C4.80027 4.22399 5.13627 4.22399 5.56827 4.22399C5.56827 4.22399 1.96827 11.424 1.53627 13.584C1.53627 13.584 -0.191727 19.584 8.25627 21.552L7.53627 22.464C7.20027 22.896 7.48827 23.52 8.01627 23.52H15.9843C16.5123 23.52 16.8003 22.896 16.4643 22.464L15.7443 21.552C24.1923 19.584 22.4643 13.584 22.4643 13.584ZM14.9283 6.23999V18.72C14.1123 18.96 13.3923 19.056 12.8643 19.152C12.7203 19.152 12.6243 19.2 12.4803 19.2V6.23999H14.9283ZM11.5203 6.23999V19.152C11.3763 19.152 11.2803 19.152 11.1363 19.104C10.6083 19.056 9.84027 18.912 9.07227 18.672V6.23999H11.5203ZM4.80027 12.048C4.80027 12.048 6.09627 8.83199 6.81627 6.23999H8.16027V18.384C5.90427 17.52 3.69627 15.744 4.80027 12.048ZM15.8403 18.384V6.23999H17.1843C17.8563 8.83199 19.2003 12.048 19.2003 12.048C20.3043 15.744 18.0963 17.52 15.8403 18.384Z"
        fill={color}
      />
    </Icon>
  );
};

const PianoIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M19.2 11.6636C16.608 11.6636 14.4 9.7916 14.016 7.2476L13.968 7.1036C13.44 3.7916 10.56 1.3916 7.24798 1.3916C3.50398 1.3916 0.47998 4.4156 0.47998 8.2076V20.6396C0.47998 21.7436 1.39198 22.6556 2.49598 22.6556H22.272C22.992 22.6556 23.52 22.0796 23.52 21.4076V14.8316C23.52 11.1356 19.248 11.6636 19.2 11.6636ZM3.26398 21.1676H1.53598V15.0236H2.87998V18.5276H3.26398V21.1676ZM5.37598 21.1676H3.64798V18.5756H4.03198V15.0716H5.03998V18.5756H5.42398V21.1676H5.37598ZM7.53598 21.1676H5.75998V18.5756H6.14398V15.0716H7.53598V21.1676ZM9.69598 21.1676H7.91998V15.0236H9.69598V21.1676ZM11.808 21.1676H10.032V15.0236H11.424V18.5276H11.808V21.1676ZM13.968 21.1676H12.192V18.5756H12.576V15.0716H13.968V21.1676ZM16.08 21.1676H14.304V15.0236H15.696V18.8636H16.08V21.1676ZM18.24 21.1676H16.464V18.9116H16.848V15.0716H17.856V18.5756H18.24V21.1676ZM20.352 21.1676H18.576V18.5756H18.96V15.0716H19.968V18.5756H20.352V21.1676ZM22.464 21.1676H20.736V18.5756H21.12V15.0716H22.464V21.1676Z"
        fill={color}
      />
    </Icon>
  );
};

const MaracaIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M10.608 7.15234L9.98405 8.35234L8.35205 7.63234L7.48805 9.21635L5.85605 8.49634L4.99205 10.0803L3.36005 9.31234L2.49605 10.8963L1.24805 10.3683C1.72805 11.3763 2.35205 12.2403 3.07205 12.9123L10.656 10.3203C10.896 9.31234 10.848 8.25634 10.608 7.15234Z"
        fill={color}
      />
      <Path
        d="M10.4157 11.5198C10.4157 11.4718 10.4157 11.4718 10.4157 11.4238L4.03174 13.6318C4.07974 13.6318 4.07974 13.6798 4.07974 13.6798C6.43174 15.4078 8.15974 17.6638 8.78374 20.5438C9.02374 19.6318 9.50374 19.5358 10.3677 18.2398C9.69574 16.0318 9.79174 13.6798 10.4157 11.5198Z"
        fill={color}
      />
      <Path
        d="M2.73601 8.44859C2.83201 8.25659 3.12001 8.16059 3.31201 8.25659L4.56001 8.83259L5.23201 7.63259C5.32801 7.44059 5.61601 7.34459 5.80801 7.44059L7.05601 8.01659L7.68001 6.72059C7.77601 6.52859 8.06401 6.43259 8.25601 6.52859L9.50401 7.10459L10.128 5.90459C10.08 5.85659 10.08 5.80859 10.032 5.71259C9.69601 4.94459 9.26401 4.22459 8.78401 3.64859L8.73601 3.60059L0.480006 6.38459V6.48059C0.432006 7.24859 0.576006 8.06459 0.768006 8.88059C0.768006 8.92859 0.816006 8.97659 0.816006 9.07259L2.06401 9.64859L2.73601 8.44859Z"
        fill={color}
      />
      <Path
        d="M8.01602 2.78421C5.04002 0.144208 1.39202 1.39221 0.624023 5.32821C0.624023 5.37621 0.624023 5.37621 0.624023 5.42421L8.11202 2.83221C8.06402 2.83221 8.06402 2.78421 8.01602 2.78421Z"
        fill={color}
      />
      <Path
        d="M20.1602 10.0804L18.4322 10.5604L17.8562 8.88041L16.1282 9.31241L15.5522 7.63241L13.8242 8.06441L13.3922 6.81641C12.9602 7.82441 12.7682 8.88041 12.7202 9.88841L19.7762 13.7284C20.5922 13.2004 21.3602 12.4324 21.9842 11.5204L20.6882 11.8564L20.1602 10.0804Z"
        fill={color}
      />
      <Path
        d="M12.8161 11.0883C13.2001 14.4483 12.4321 17.6643 10.0801 20.2563C8.40008 22.1283 12.0001 23.8083 12.5761 21.6003C13.4401 18.1923 15.5521 15.8403 18.7201 14.2563C18.7681 14.2563 18.7681 14.2083 18.7681 14.2083L12.7681 10.9443C12.8161 11.0403 12.8161 11.0403 12.8161 11.0883Z"
        fill={color}
      />
      <Path
        d="M14.0161 5.56791L14.4481 6.86391C15.2161 6.76791 16.0801 6.19191 16.3201 6.81591L16.7521 8.11191C17.5681 7.96791 18.3841 7.43991 18.6241 8.06391L19.0561 9.35991C19.8241 9.26391 20.7361 8.68791 20.9281 9.3119L21.3601 10.6079C22.7041 10.2719 22.6561 10.2719 22.7041 10.2719C23.2801 8.9759 23.2801 8.63991 23.4721 7.67991L15.7441 3.50391C15.3121 3.79191 14.6401 4.55991 14.0161 5.56791Z"
        fill={color}
      />
      <Path
        d="M16.5601 2.87987L23.5201 6.67187C23.5201 2.92787 20.3521 0.62387 16.5601 2.87987Z"
        fill={color}
      />
    </Icon>
  );
};

const AdultIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12.1071 5.34984C13.4047 5.29162 14.409 4.18171 14.3502 2.8708C14.2914 1.55988 13.1918 0.544369 11.8941 0.60259C10.5964 0.660811 9.59211 1.77072 9.65093 3.08163C9.70974 4.39255 10.8094 5.40806 12.1071 5.34984Z"
        fill={color}
      />
      <Path
        d="M17.5198 12.1203L15.8878 7.6803C15.5038 6.6243 14.4718 5.9043 13.3438 5.9043H10.6558C9.52781 5.9043 8.51981 6.6003 8.11181 7.6803L6.47981 12.1443C6.28781 12.6483 6.55181 13.2243 7.05581 13.3923C7.55981 13.5843 8.13581 13.3203 8.30381 12.8163L9.38381 9.8643V22.2243C9.38381 22.8243 9.81581 23.3523 10.4158 23.4003C11.0878 23.4723 11.6638 22.9443 11.6638 22.2723V14.9763C11.6638 14.7843 11.8078 14.6403 11.9998 14.6403C12.1918 14.6403 12.3358 14.7843 12.3358 14.9763V22.2243C12.3358 22.8243 12.7678 23.3523 13.3678 23.4003C14.0398 23.4723 14.6158 22.9443 14.6158 22.2723V9.8643L15.6958 12.8163C15.8398 13.2003 16.2238 13.4643 16.6078 13.4643C16.7758 13.4643 16.9678 13.4163 17.1358 13.3203C17.5198 13.0803 17.6878 12.5523 17.5198 12.1203Z"
        fill={color}
      />
    </Icon>
  );
};

const OlderChildIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M14.2374 4.69419C14.2586 3.43511 13.255 2.39729 11.9959 2.37617C10.7368 2.35504 9.69902 3.3586 9.6779 4.61769C9.65677 5.87677 10.6603 6.91459 11.9194 6.93571C13.1785 6.95684 14.2163 5.95327 14.2374 4.69419Z"
        fill={color}
      />
      <Path
        d="M18.1436 7.63219L17.6396 7.34419C17.6636 7.27219 17.6876 7.17619 17.7356 7.10419C17.8796 6.67219 17.6636 6.21619 17.2316 6.04819C16.7996 5.90419 16.3436 6.12019 16.1996 6.52819L15.8876 6.36019C15.8876 6.07219 15.7196 5.83219 15.4556 5.68819C15.0716 5.49619 14.5916 5.64019 14.3996 6.02419C14.2076 6.40819 14.3516 6.88819 14.7356 7.08019C14.9756 7.20019 15.2636 7.17619 15.4796 7.05619L15.9116 7.24819C15.5996 8.06419 15.2636 8.88019 14.9996 9.33619C14.9036 9.24019 14.7836 9.14419 14.6876 9.07219C14.0396 8.49619 13.1756 7.72819 12.0476 7.44019C11.8556 7.39219 11.0156 7.20019 10.3676 7.00819C8.37561 6.45619 6.86361 8.16019 6.38361 8.71219C6.33561 8.76019 6.31161 8.80819 6.26361 8.83219C5.71161 9.38419 5.32761 11.1122 5.13561 12.0962C5.03961 12.5522 5.35161 12.9842 5.78361 13.0562C5.83161 13.0562 5.87961 13.0802 5.92761 13.0802C6.31161 13.0802 6.64761 12.8162 6.74361 12.4082C6.93561 11.3522 7.27161 10.2242 7.43961 9.98419C7.48761 9.93619 7.91961 9.45619 8.08761 9.28819C7.63161 10.7282 7.36761 12.4562 7.39161 13.6322C7.41561 14.8082 7.65561 15.2642 7.91961 16.0082C8.13561 16.6082 8.37561 17.3042 8.30361 17.7122C8.15961 18.5762 7.34361 21.0722 7.03161 21.9362C6.83961 22.4882 7.12761 23.0882 7.67961 23.2802C7.79961 23.3282 7.91961 23.3282 8.01561 23.3282C8.44761 23.3282 8.87961 23.0402 9.02361 22.6082C9.14361 22.2722 10.1756 19.2482 10.3916 18.0482C10.4876 17.4482 10.3916 16.8242 10.2236 16.2482C10.6316 16.8722 10.9676 17.5922 11.0396 17.9522C11.1836 18.6722 11.4476 21.3602 11.5196 22.3202C11.5676 22.8722 12.0236 23.2802 12.5756 23.2802C12.5996 23.2802 12.6476 23.2802 12.6716 23.2802C13.2476 23.2322 13.6796 22.7042 13.6316 22.1282C13.7036 21.8402 13.4156 18.6002 13.1996 17.6162C13.1036 17.1602 12.5756 15.8882 11.8076 14.7602C11.8556 13.8242 12.0476 11.1122 12.5996 9.52819C12.9596 9.76819 13.3196 10.0802 13.6076 10.3442C14.0876 10.7762 14.5916 11.2322 15.1436 11.2322C15.3116 11.2322 15.4556 11.1842 15.6236 11.1122C15.8396 11.0162 16.3676 10.7522 17.3996 7.99219L17.8556 8.20819C17.9276 8.25619 18.0476 8.20819 18.0716 8.13619L18.2156 7.87219C18.2636 7.77619 18.2156 7.68019 18.1436 7.63219Z"
        fill={color}
      />
      <Path
        d="M18.5279 0.599738L16.4159 0.911738C16.2719 0.935738 16.1759 1.05574 16.1759 1.17574V3.14374C16.0559 3.09574 15.9119 3.09574 15.7679 3.11974C15.3839 3.19174 15.1439 3.50374 15.2159 3.81574C15.2879 4.12774 15.6239 4.31974 16.0079 4.24774C16.3439 4.17574 16.5839 3.93574 16.5839 3.64774V1.70374L18.4559 1.41574V2.80774C18.3359 2.75974 18.1919 2.75974 18.0479 2.78374C17.6639 2.85574 17.4239 3.16774 17.4959 3.47974C17.5679 3.79174 17.9039 3.98374 18.2879 3.91174C18.6239 3.83974 18.8639 3.59974 18.8639 3.31174V0.863738C18.8399 0.695738 18.6959 0.575738 18.5279 0.599738Z"
        fill={color}
      />
    </Icon>
  );
};

const BabyIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M18.3839 9.16802C17.9759 8.83202 17.3519 8.90402 17.0159 9.31202L15.2399 11.496C14.7599 12.072 14.0399 12.432 13.2959 12.432H11.2799C10.6319 12.432 10.0319 12.672 9.55186 13.104L7.72786 14.76C7.55986 13.68 7.41586 11.976 7.84786 10.584C8.32786 9.04802 8.35186 7.53602 8.25586 6.48002C9.33586 6.16802 10.1519 4.99202 10.1519 3.60002C10.1519 1.96802 9.04786 0.624023 7.70386 0.624023C6.33586 0.624023 5.25586 1.94402 5.25586 3.60002C5.25586 5.06402 6.14386 6.26402 7.29586 6.50402C7.39186 7.41602 7.41586 8.78402 6.95986 10.272C6.35986 12.168 6.69586 14.448 6.91186 15.504L6.74386 15.648C6.35986 16.008 6.31186 16.608 6.67186 17.016C6.86386 17.232 7.12786 17.328 7.39186 17.328C7.63186 17.328 7.84786 17.256 8.03986 17.088L9.76786 15.528V22.464C9.76786 22.992 10.1999 23.424 10.7279 23.424C11.2559 23.424 11.6879 22.992 11.6879 22.464V18.576C11.6879 18.432 11.8079 18.312 11.9519 18.312H12.8399C12.9839 18.312 13.1039 18.432 13.1039 18.576V22.44C13.1039 22.968 13.5359 23.4 14.0639 23.4C14.5919 23.4 15.0239 22.968 15.0239 22.44V13.992C15.6959 13.704 16.2719 13.272 16.7519 12.696L18.5279 10.512C18.8639 10.104 18.7919 9.50402 18.3839 9.16802Z"
        fill={color}
      />
      <Path
        d="M12.4077 11.8085C13.7066 11.8085 14.7597 10.7555 14.7597 9.45649C14.7597 8.15752 13.7066 7.10449 12.4077 7.10449C11.1087 7.10449 10.0557 8.15752 10.0557 9.45649C10.0557 10.7555 11.1087 11.8085 12.4077 11.8085Z"
        fill={color}
      />
    </Icon>
  );
};

const YoungerChildIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9.4253 6.02617C11.0887 6.02425 12.4385 4.67545 12.4385 3.01297C12.4385 1.34569 11.089 -0.00383078 9.4253 9.22532e-06C7.7597 -0.00407078 6.41042 1.34569 6.41162 3.01297C6.41042 4.67569 7.75946 6.02449 9.4253 6.02617Z"
        fill={color}
      />
      <Path
        d="M17.6901 21.015C17.6805 20.9979 17.6673 20.9845 17.6567 20.9682L17.6617 20.9653C17.6617 20.9653 15.5874 18.1165 12.6186 14.0758L12.5833 12.3318V10.0083L15.0887 12.513C16.0936 13.5788 17.626 12.1544 16.5762 11.1094L12.4986 7.01937C12.1636 6.69105 11.7801 6.49065 11.2156 6.48633H9.42446H7.59686C7.02542 6.49089 6.6671 6.69729 6.3383 7.01937L2.3087 11.061C1.20326 12.1678 2.6951 13.5788 3.79742 12.4765L6.23006 10.0198V12.3318V13.6878V13.688C5.5859 19.0966 5.14046 22.9863 5.14046 22.9863H5.14622C5.14502 23.0055 5.14046 23.0235 5.14046 23.0432C5.14046 23.5717 5.56886 23.9998 6.09734 23.9998C6.55526 23.9998 6.9371 23.6778 7.03094 23.2479H7.03214L7.68758 20.599C8.29766 18.1786 8.77406 16.1002 8.77406 16.1002L10.2865 15.9392C10.2856 15.9411 10.2846 15.9438 10.2846 15.9438L11.1059 16.765C11.1059 16.765 12.556 18.3502 14.2881 20.1637L16.1365 22.1156C16.1373 22.1163 16.138 22.117 16.1385 22.1178L16.1452 22.1247L16.1457 22.1245C16.4397 22.4526 16.9307 22.545 17.3289 22.3191C17.7897 22.0587 17.9505 21.4748 17.6901 21.015Z"
        fill={color}
      />
      <Path
        d="M19.679 19.8843C20.9992 19.8843 22.0694 18.8141 22.0694 17.4939C22.0694 16.1737 20.9992 15.1035 19.679 15.1035C18.3588 15.1035 17.2886 16.1737 17.2886 17.4939C17.2886 18.8141 18.3588 19.8843 19.679 19.8843Z"
        fill={color}
      />
    </Icon>
  );
};

const ApprovedIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M22.6053 11.5346L21.4878 9.83209L21.7578 7.81459C21.7953 7.48459 21.6378 7.14709 21.3528 6.97459L19.6053 5.92459L18.9753 3.98959C18.8703 3.66709 18.5778 3.44209 18.2478 3.40459L16.2228 3.21709L14.8128 1.75459C14.5728 1.50709 14.2203 1.42459 13.9053 1.54459L12.0003 2.26459L10.0953 1.55209C9.78025 1.43209 9.42025 1.51459 9.18775 1.76209L7.77775 3.22459L5.75275 3.41209C5.41525 3.44959 5.13025 3.67459 5.02525 3.99709L4.38775 5.93209L2.64775 6.97459C2.35525 7.14709 2.19775 7.47709 2.24275 7.81459L2.51275 9.83209L1.39525 11.5346C1.21525 11.8196 1.21525 12.1796 1.39525 12.4646L2.51275 14.1671L2.24275 16.1771C2.19775 16.5146 2.35525 16.8446 2.64775 17.0171L4.38775 18.0671L5.01775 20.0021C5.12275 20.3246 5.40775 20.5496 5.74525 20.5796L7.77025 20.7746L9.18025 22.2371C9.42025 22.4771 9.77275 22.5671 10.0878 22.4471L12.0003 21.7346L13.9053 22.4471C14.0028 22.4846 14.1003 22.4996 14.1978 22.4996C14.4228 22.4996 14.6478 22.4096 14.8128 22.2371L16.2228 20.7746L18.2478 20.5871C18.5778 20.5496 18.8703 20.3246 18.9753 20.0021L19.6053 18.0671L21.3528 17.0171C21.6378 16.8446 21.8028 16.5146 21.7578 16.1771L21.4878 14.1596L22.6053 12.4571C22.7928 12.1796 22.7928 11.8196 22.6053 11.5346ZM16.7478 9.85459L11.2503 15.3521C11.0928 15.5096 10.8753 15.5921 10.6503 15.5921C10.4328 15.5921 10.2078 15.5096 10.0503 15.3521L7.25275 12.5546C6.92275 12.2246 6.92275 11.6921 7.25275 11.3546C7.58275 11.0246 8.12275 11.0246 8.45275 11.3546L10.6503 13.5521L15.5403 8.66209C15.8703 8.33209 16.4103 8.33209 16.7478 8.66209C17.0778 8.98459 17.0778 9.52459 16.7478 9.85459Z"
        fill={color}
      />
    </Icon>
  );
};

const FavoriteIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z"
        fill={color}
        stroke={color}
        strokeWidth="2"
      />
    </Icon>
  );
};

const LastPlayIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect x="2" y="3" width="3" height="18" rx="1" fill={color} />
      <Path
        d="M8.62853 10.7942L19.7652 3.24558C20.715 2.60072 22 3.30248 22 4.45942V19.5377C22 20.7136 20.715 21.3964 19.7652 20.7515L8.62853 13.2029C7.79049 12.6529 7.79049 11.3632 8.62853 10.7942Z"
        fill={color}
      />
    </Icon>
  );
};

const NextPlayIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect x="19" y="3" width="3" height="18" rx="1" fill={color} />
      <Path
        d="M15.3715 10.7942L4.23479 3.24558C3.285 2.60072 2 3.30248 2 4.45942V19.5377C2 20.7136 3.285 21.3964 4.23479 20.7515L15.3715 13.2029C16.2095 12.6529 16.2095 11.3632 15.3715 10.7942Z"
        fill={color}
      />
    </Icon>
  );
};

const PlayIcon = ({ color = "#FFFFFF", ...props }: any) => {
  return (
    <svg viewBox="0 0 24 24" {...props} color="transparent">
      <path
        d="M20.2817 10.6602L7.55404 2.27286C6.46857 1.55636 5 2.33609 5 3.62158V20.3752C5 21.6818 6.46857 22.4404 7.55404 21.7239L20.2817 13.3366C21.2394 12.7254 21.2394 11.2924 20.2817 10.6602Z"
        fill={color}
      />
    </svg>
  );
};

const PauseIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect x="6" y="3" width="3" height="18" rx="1" fill={color} />
      <Rect x="15" y="3" width="3" height="18" rx="1" fill={color} />
    </Icon>
  );
};

const FemaleIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M20.272 21.168H4.264C4.12 21.168 4 21.048 4 20.904V18.84C4 17.784 4.984 16.92 7.024 16.176C8.56 15.624 9.328 15.12 9.64 14.424C6.76 13.704 6.424 11.952 6.424 11.88C6.4 11.784 6.448 11.664 6.544 11.616C6.592 11.568 7.984 10.632 7.984 8.232C7.984 5.64 8.488 3 12.28 3C16.072 3 16.576 5.64 16.576 8.232C16.576 10.632 17.944 11.568 18.016 11.616C18.112 11.664 18.16 11.784 18.136 11.88C18.112 11.952 17.776 13.704 14.944 14.424C15.256 15.12 16.024 15.6 17.56 16.176C19.6 16.92 20.584 17.784 20.584 18.84V20.904C20.56 21.048 20.44 21.168 20.272 21.168Z"
        fill={color}
      />
    </Icon>
  );
};

const MaleIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M19.888 21.0194H4.312C4.144 21.0194 4 20.8754 4 20.7074V18.7394C4 17.7074 4.96 16.8674 6.904 16.1714C9.16 15.3554 9.568 14.7314 9.568 13.3874C9.568 13.0514 9.496 12.9554 9.352 12.7394C9.16 12.4754 8.92 12.0914 8.728 11.1314C8.704 11.0114 8.704 11.0114 8.584 10.9394C8.248 10.7714 7.936 10.5554 7.864 9.49939C7.864 8.99539 8.032 8.70739 8.176 8.56339C8.152 8.37139 8.104 8.08339 8.056 7.74739C7.816 6.23539 7.792 4.38739 9.928 3.52339C11.824 2.75539 13.552 2.89939 13.912 3.52339C13.936 3.57139 13.96 3.64339 13.96 3.69139C13.984 3.78739 14.008 3.85939 14.008 3.90739H14.032C14.296 3.85939 14.872 3.78739 15.472 4.45939C16.384 5.51539 16.096 7.86739 16 8.53939C16.144 8.68339 16.312 8.97139 16.312 9.45139C16.24 10.5314 15.928 10.7474 15.592 10.9154C15.472 10.9634 15.472 10.9874 15.448 11.1074C15.28 12.0674 15.016 12.4274 14.824 12.7154C14.68 12.9074 14.608 13.0274 14.608 13.3634C14.608 14.7074 15.016 15.3314 17.272 16.1474C19.216 16.8674 20.176 17.7074 20.176 18.7154V20.6834C20.2 20.8754 20.056 21.0194 19.888 21.0194Z"
        fill={color}
      />
    </Icon>
  );
};

const VideoFillIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8163 15.62C15.8163 17.613 14.4583 19.021 12.2863 19.021H6.06929C3.89929 19.021 2.55029 17.613 2.55029 15.62V8.66C2.55029 6.668 3.89929 5.25 6.08029 5.25H12.2863C14.4583 5.25 15.8163 6.668 15.8163 8.66V15.62Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8164 11.2766L19.9134 7.9226C20.5634 7.3876 21.5504 7.8526 21.5504 8.6996V15.5716C21.5504 16.4196 20.5634 16.8826 19.9134 16.3486L15.8164 12.9946"
        fill={color}
      />
    </Icon>
  );
};

const NotificationUnreadIcon = ({
  color = "#FFFFFF",
  activeColor,
  ...props
}: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12.5 4H12V4C9.15349 4 6.76219 6.14032 6.44784 8.96942L6.19604 11.2356C6.19283 11.2645 6.19123 11.279 6.18959 11.2933C6.06064 12.4169 5.69488 13.5005 5.11644 14.4725C5.10909 14.4849 5.10161 14.4973 5.08665 14.5222L4.50862 15.4856C3.98407 16.3599 3.72179 16.797 3.77841 17.1559C3.81609 17.3946 3.93897 17.6117 4.12434 17.7668C4.40291 18 4.91268 18 5.93223 18H17.4676C19.0337 18 19.8168 18 20.104 17.4927C20.3912 16.9854 19.9884 16.3139 19.1826 14.971L18 13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9.10222 18.4059C9.27315 19.1501 9.64978 19.8077 10.1737 20.2767C10.6976 20.7458 11.3396 21 12 21C12.6604 21 13.3024 20.7458 13.8263 20.2767C14.3502 19.8077 14.7269 19.1501 14.8978 18.4059"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Circle cx="18" cy="7" r="5" fill={activeColor || color} />
    </Icon>
  );
};

export {
  TileFillIcon,
  LockFillIcon,
  SoundMuteIcon,
  SoundMinIcon,
  SettingFillIcon,
  MusicFillIcon,
  WalletIcon,
  HeadPhonesIcon,
  GuitarIcon,
  DrumIcon,
  MicrophoneIcon,
  LyreIcon,
  PianoIcon,
  MaracaIcon,
  AdultIcon,
  OlderChildIcon,
  BabyIcon,
  YoungerChildIcon,
  ApprovedIcon,
  FavoriteIcon,
  LastPlayIcon,
  NextPlayIcon,
  PlayIcon,
  PauseIcon,
  FemaleIcon,
  MaleIcon,
  VideoFillIcon,
  NotificationUnreadIcon,
};
